import { EVMChain, SVMChain } from '../types';
import { ConnectionState } from '../wallet';
import { getNativeSymbol } from '../networks';
export const NFT_FAVORITE_KEY = 'nftFavorites';
export const SVM_MAX_MINT_COUNT = 2;
export const SVM_MAX_BUY_COUNT = 3;
export const SVM_MAX_LIST_COUNT = 4;
export const SVM_MAX_DELIST_COUNT = 6;
export const SVM_MAX_PRICE_UPDATE_COUNT = 10;
export const DEFAULT_BATCH_SIZE = 10;
/** Elevated batch size for NFT-whitelisted Pro wallets (matches on-chain default). */
export const WHITELIST_BATCH_SIZE = 100;
/** Default network when wallet is disconnected or network is unset. */
export const DEFAULT_CHAIN = EVMChain.Ethereum;
const DEFAULT_CHAIN_STATE = {
    walletAddress: '',
    isStable: false,
    isActive: true,
    global: null,
    balance: 0,
    symbol: 'Unknown',
    listedNfts: [],
    myNfts: [],
    myListedNfts: [],
    allListedNfts: [],
    defaultBatchSize: DEFAULT_BATCH_SIZE,
    whitelistBatchSize: WHITELIST_BATCH_SIZE,
    maxMintCount: DEFAULT_BATCH_SIZE,
    maxBuyCount: DEFAULT_BATCH_SIZE,
    maxDelistCount: DEFAULT_BATCH_SIZE,
    maxListCount: DEFAULT_BATCH_SIZE,
    maxPriceUpdateCount: DEFAULT_BATCH_SIZE,
    isLoadingGlobalState: false,
    isLoadingUserState: false,
    isLoadingListedNfts: false,
    isLoadingMyNfts: false,
    isLoadingMyListedNfts: false,
};
export const DEFAULT_DAPP_STATE = {
    [SVMChain.Solana]: {
        ...DEFAULT_CHAIN_STATE,
        symbol: getNativeSymbol(SVMChain.Solana),
        currency: 'USD',
        maxMintCount: SVM_MAX_MINT_COUNT,
        maxBuyCount: SVM_MAX_BUY_COUNT,
        maxListCount: SVM_MAX_LIST_COUNT,
        maxDelistCount: SVM_MAX_DELIST_COUNT,
        maxPriceUpdateCount: SVM_MAX_PRICE_UPDATE_COUNT,
        defaultBatchSize: SVM_MAX_MINT_COUNT,
        whitelistBatchSize: SVM_MAX_MINT_COUNT,
    },
    [EVMChain.Ethereum]: {
        ...DEFAULT_CHAIN_STATE,
        symbol: getNativeSymbol(EVMChain.Ethereum),
        currency: 'ETH',
    },
    [EVMChain.Monad]: {
        ...DEFAULT_CHAIN_STATE,
        symbol: getNativeSymbol(EVMChain.Monad),
        currency: 'MON',
    },
};
export const DEFAULT_WALLET_CONNECTION = {
    wallet: undefined,
    network: undefined,
    address: undefined,
    connectionState: ConnectionState.Disconnected,
};
